import React from 'react';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function Resources() {
  const { language } = useLanguage();
  const t = CONTENT[language].resources;

  return (
    <div className="py-20 bg-suncoast-offWhite">
      <div className="container mx-auto px-4 lg:px-12">
        <h1 className="text-4xl font-bold text-center mb-4 text-suncoast-dark">{t.title}</h1>
        <p className="text-center text-gray-600 mb-12">{t.subtitle}</p>

        <div className="grid md:grid-cols-3 gap-8">
          {t.list.map(res => (
            <div key={res.id} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <span className="text-xs font-bold text-suncoast-accent uppercase tracking-wide">{res.category}</span>
              <h3 className="text-lg font-bold mt-2 mb-4 text-gray-800">{res.title}</h3>
              <div className="flex justify-between items-center mt-auto">
                <span className="text-sm text-gray-400">{res.readTime} read</span>
                <button className="text-suncoast-primary font-bold text-sm hover:underline">Read Now</button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <div className="inline-block bg-suncoast-primary text-white p-8 rounded-xl">
             <h3 className="text-xl font-bold mb-2">{t.cheatSheetTitle}</h3>
             <p className="mb-4 text-sm opacity-90">{t.cheatSheetDesc}</p>
             <button className="bg-white text-suncoast-primary px-6 py-2 rounded font-bold hover:bg-gray-100">{t.downloadBtn}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
